import { render, staticRenderFns } from "./OrderFood.vue?vue&type=template&id=2e3738be&"
import script from "./OrderFood.vue?vue&type=script&lang=js&"
export * from "./OrderFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports